var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var MarquesVehiclesFilter = /** @class */ (function (_super) {
    __extends(MarquesVehiclesFilter, _super);
    function MarquesVehiclesFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = '';
        _this.descripcion = '';
        _this.referenciaIntegracion = '';
        _this.labels['id'] = _this.i18n('Id');
        _this.labels['descripcion'] = _this.i18n('Descripció');
        _this.labels['referenciaIntegracion'] = _this.i18n('Referencia Integració');
        return _this;
    }
    return MarquesVehiclesFilter;
}(FilterData));
export { MarquesVehiclesFilter };
